import { useLang } from 'hooks/lang';

import { getStatusConfig } from 'entities';

import { Tag, TagProps } from 'components/Blocks';
import { cn } from 'styles';

type StatusTarget = Parameters<typeof getStatusConfig>[0];

type EntityStatusTagProps = Omit<TagProps, 'name' | 'color'> & {
  target: StatusTarget;
  status: string;
};

export function EntityStatusTag({ status, target, ...props }: EntityStatusTagProps) {
  const { t } = useLang();

  const config = getStatusConfig(target, status);

  if (!config) return null;

  return (
    <Tag
      {...props}
      name={config.getLabel(t)}
      color={config.color}
      // revise!
      className={cn(props.className, 'dark:opacity-90')}
    />
  );
}
